import React from 'react';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import { FaHeartbeat, FaServer, FaDatabase, FaCloud } from 'react-icons/fa';

const HealthMonitor = ({ health }) => {
    const getHealthBadge = (status) => {
        if (status === 'Online') return <Badge bg="success">Online</Badge>;
        if (status === 'Offline') return <Badge bg="danger">Offline</Badge>;
        return <Badge bg="secondary">{status}</Badge>;
    };

    return (
        <div className="mt-5 mb-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="mb-0 d-flex align-items-center">
                    <FaHeartbeat className="text-danger me-2" /> System Health Monitor
                </h4>
                <div className="text-muted small">Auto-refreshing every 30s</div>
            </div>

            <Row className="g-4">
                <Col md={4}>
                    <Card className="border-0 shadow-sm text-center p-3 h-100">
                        <FaServer size={30} className="mx-auto mb-3 text-primary" />
                        <h6>Backend API</h6>
                        <div>{getHealthBadge(health.backend)}</div>
                        <div className="mt-2 small text-muted">Response: {health.uptime}s</div>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="border-0 shadow-sm text-center p-3 h-100">
                        <FaDatabase size={30} className="mx-auto mb-3 text-info" />
                        <h6>Main Database</h6>
                        <div>{getHealthBadge(health.database)}</div>
                        <div className="mt-2 small text-muted">MongoDB Atlas</div>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="border-0 shadow-sm text-center p-3 h-100">
                        <FaCloud size={30} className="mx-auto mb-3 text-warning" />
                        <h6>Cashfree Gateway</h6>
                        <div>{getHealthBadge(health.cashfree)}</div>
                        <div className="mt-2 small text-muted">Production API</div>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default HealthMonitor;
